export default function LuggageService(
    l10nService,
    currencyByCodeFilter
) {
    'ngInject';
            const cachedBagsData = {};
            const DEFAULT_BAGS_VALUE = {text: l10nService.localize('No bags'), value: 0};

            function checkAvailability(configList, property, checkFunction) {
                let isAvailable = false;

                _.each(configList, function(config) {
                    if (!config) {
                        return;
                    }
                    if (isAvailable) {
                        return;
                    }

                    if (config[property]) {
                        isAvailable = !!_.find(config[property], checkFunction);
                    } else {
                        isAvailable = true;
                    }
                });

                return isAvailable;
            }

            function getOptionTitle(option, currencyCode) {
                const bagsCount = option.Bags ? option.Bags : option.Weights.length;
                let title = [bagsCount, l10nService.localize((bagsCount === 1) ? 'bag' : 'bags')].join(' ');
                const totalLabel = l10nService.localize('total');

                if (option.TotalWeight) {
                    title += ' ' + option.TotalWeight + ' kg ' + totalLabel + ': ' + currencyByCodeFilter(option.Amount, currencyCode);
                } else {
                    title += (bagsCount === 1)
                        ? ' x ' + option.Weights[0] + ' kg: ' + currencyByCodeFilter(option.Amount, currencyCode)
                        : ' (' + option.Weights.join(' kg + ') + ' kg): ' + currencyByCodeFilter(option.Amount, currencyCode);
                }

                return title;
            }

            function copyBagForFlight(luggageModels, recommendationId, selectedBag) {
                _.each(luggageModels, function(luggageModel) {
                    _.each(luggageModel.model, function(luggageGroupModel) {
                        if (luggageGroupModel.recommendationId !== recommendationId) {
                            return;
                        }
                        luggageGroupModel.bags = angular.copy(selectedBag);
                    });
                });
            }

            return {
                luggageConfig: null,
                isAdult: function(traveller) {
                    return (traveller.PassengerType === 'Adult');
                },

                isLuggageAvailableForTraveller: function(configList, travellerId) {
                    return checkAvailability(configList, 'TripPassengerIds', function(passengerId) {
                        return passengerId === travellerId;
                    });
                },

                isLuggageAvailableForFlightGroupId: function(configList, flightGroupId, recommendationId) {
                    if (!isLuggageEnabled()) {
                        return false;
                    }

                    return checkAvailability(configList, 'TripItemFlightGroupIds', function(groupId) {
                        return groupId === flightGroupId;
                    });

                    function isLuggageEnabled() {
                        return _.find(configList, {TripItemFlightRecommendationId: recommendationId});
                    }
                },

                createModel: function(configList, flights, travellerData) {
                    const luggageModel = {};
                    const travellerId = travellerData.Id || travellerData.TripPassengerId;

                    function getOptionData(luggageOptionId) {
                        const optionData = {option: null, currency: null};

                        _.each(configList, function(config) {
                            if (!config) {
                                return;
                            }

                            _.each(config.Options, function(option) {
                                if (luggageOptionId === option.Id) {
                                    optionData.option = angular.copy(option);
                                    optionData.currency = config.CurrencyCode;
                                }
                            });
                        });

                        return optionData;
                    }

                    _.each(flights, (flight) => {
                        _.each(flight.FlightGroups, (group) => {
                            const luggage = getLuggage.call(this, flight, group);

                            let bagsValue = angular.copy(DEFAULT_BAGS_VALUE);
                            let optionData;

                            if (luggage) {
                                optionData = getOptionData(luggage.LuggageOptionId);
                                bagsValue = {
                                    text: getOptionTitle(optionData.option, optionData.currency),
                                    value: luggage.LuggageOptionId,
                                };
                            }

                            if (!this.isFlightHasDifferentLuggageOptionsPerSegment(flight.Id)) {
                                if (isLuggageAlreadyAdded(travellerId, flight)) {
                                    return;
                                }
                            }

                            luggageModel[group.Id] = {
                                bags: bagsValue,
                                recommendationId: flight.Id,
                                travellerId,
                            };
                        });
                    });

                    return luggageModel;

                    function isLuggageAlreadyAdded(passengerId, flight) {
                        return _.find(luggageModel, {recommendationId: flight.Id, travellerId: passengerId});
                    }

                    function getLuggage(flight, group) {
                        return this.isFlightHasDifferentLuggageOptionsPerSegment(flight.Id)
                            ? _.find(travellerData.Luggages, {
                                FlightRecommendationId: flight.Id,
                                FlightGroupId: group.Id,
                        }) : _.find(travellerData.Luggages, {FlightRecommendationId: flight.Id});
                    }

                },

                generateBagsData: function(configList, recommendationId, groupId) {
                    const dropdownData = [angular.copy(DEFAULT_BAGS_VALUE)];
                    const key = recommendationId + '|' + groupId;

                    if (cachedBagsData[key]) {
                        return cachedBagsData[key];
                    }

                    _.each(configList, function(config) {
                        if (!config) {
                            return;
                        }

                        if (config.TripItemFlightRecommendationId === recommendationId && config.TripItemFlightGroupIds.includes(groupId)) {
                            _.each(config.Options, function(option) {
                                dropdownData.push({
                                    value: option.Id,
                                    text: getOptionTitle(option, config.CurrencyCode),
                                });
                            });
                        }
                    });

                    cachedBagsData[key] = dropdownData;

                    return dropdownData;
                },

                checkLinkedModels: function(tripFactory, configList, travellerId, recommendationId, groupId,
                                             selectedBag) {
                    const config = _.find(configList, {TripItemFlightRecommendationId: recommendationId});
                    const luggageModels = tripFactory.getAllLuggageModels();

                    if (config.TripItemFlightGroupIds === null) {
                        copyBagForFlight(luggageModels, recommendationId, selectedBag);
                    } else if (config.TripItemFlightGroupIds.indexOf(groupId) !== -1) {
                        _.each(config.TripItemFlightGroupIds, function(linkedGroupId) {
                            if (linkedGroupId === groupId) {
                                return;
                            }

                            _.each(luggageModels, function(luggageModel) {
                                _.each(luggageModel.model, function(luggageGroupModel, luggageGroupId) {
                                    if (luggageGroupModel.recommendationId !== recommendationId) {
                                        return;
                                    }
                                    if (luggageGroupId !== linkedGroupId) {
                                        return;
                                    }

                                    luggageGroupModel.bags = angular.copy(selectedBag);
                                });
                            });
                        });
                    }

                    if (config.TripPassengerIds === null) {
                        copyBagForFlight(luggageModels, recommendationId, selectedBag);
                    } else if (config.TripPassengerIds.indexOf(travellerId) !== -1) {
                        _.each(config.TripPassengerIds, function(linkedTravellerId) {
                            if (linkedTravellerId === travellerId) {
                                return;
                            }

                            _.each(luggageModels, function(luggageModel) {
                                _.each(luggageModel.model, function(luggageGroupModel) {
                                    if (luggageGroupModel.recommendationId !== recommendationId) {
                                        return;
                                    }
                                    if (luggageGroupModel.travellerId !== linkedTravellerId) {
                                        return;
                                    }

                                    luggageGroupModel.bags = angular.copy(selectedBag);
                                });
                            });
                        });
                    }
                },

                getCosts: function(configList, luggageModel) {
                    const allCosts = {amount: 0, code: ''};

                    function getCosts(flightLuggage) {
                        let bagsOption = null;
                        let costs = null;

                        _.each(configList, function(config) {
                            if (!config) {
                                return;
                            }
                            if (costs) {
                                return;
                            }

                            if (config.TripItemFlightRecommendationId === flightLuggage.recommendationId) {
                                bagsOption = _.find(config.Options, {Id: flightLuggage.bags.value});
                                costs = {amount: bagsOption.Amount, code: config.CurrencyCode};
                            }
                        });

                        return costs;
                    }

                    _.each(luggageModel, function(flightLuggage) {
                        if (!flightLuggage.bags.value) {
                            return;
                        }

                        const costs = getCosts(flightLuggage);
                        allCosts.amount += costs.amount;
                        allCosts.code = costs.code;
                    });

                    return allCosts;
                },

                getRequestData: function(configList, luggageModel) {
                    const requestData = [];

                    _.each(luggageModel, function(flightLuggage, groupId) {
                        if (!this.getLuggageConfigByFlightId(flightLuggage.recommendationId)) {
                            return;
                        }

                        if (!flightLuggage.bags.value || luggageDataForSameFlightHasBeenAlreadyAdded()) {
                            return;
                        }

                        const isFlightHasDifferentLuggageOptionsPerSegment
                            = this.isFlightHasDifferentLuggageOptionsPerSegment(flightLuggage.recommendationId);

                        const luggageData = {
                            LuggageOptionId: flightLuggage.bags.value,
                            TripItemFlightRecommendationId: flightLuggage.recommendationId,
                            TripPassengerId: flightLuggage.travellerId,
                        };

                        if (this.isFlightHasDifferentLuggageOptionsPerSegment(flightLuggage.recommendationId)) {
                            luggageData.TripItemFlightGroupId = parseInt(groupId, 10);
                        }

                        requestData.push(luggageData);

                        function luggageDataForSameFlightHasBeenAlreadyAdded() {
                            return !isFlightHasDifferentLuggageOptionsPerSegment
                                && _.find(requestData, {
                                    TripItemFlightRecommendationId: flightLuggage.recommendationId,
                                    TripItemFlightGroupId: groupId,
                                });
                        }

                    }, this);

                    return requestData;
                },

                isFlightHasDifferentLuggageOptionsPerSegment: function(recommendationId) {
                    const flightConfig = this.getLuggageConfigByFlightId(recommendationId);
                    return flightConfig && flightConfig.IsSpecifiedPerFlight !== false;
                },

                getLuggageConfigByFlightId: function(flightRecommendationId) {
                    return _.find(this.luggageConfig, {TripItemFlightRecommendationId: flightRecommendationId});
                },

            };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/luggageService.js